export const AI_REVIEW_STATES = {
  INITIAL: 'INITIAL',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;

export const TERMINAL_REVIEW_STATES: ReadonlySet<string> = new Set([
  AI_REVIEW_STATES.COMPLETED,
  AI_REVIEW_STATES.FAILED,
  AI_REVIEW_STATES.CANCELLED,
]);

export const EXECUTION_STEP_STATUSES = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  ON_REVIEW: 'ON_REVIEW',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
  RETRYING: 'RETRYING',
  CANCELLED: 'CANCELLED',
} as const;

export const AI_TASK_STATUSES = {
  INITIAL: 'INITIAL',
  QUEUED: 'QUEUED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  TIMEOUT: 'TIMEOUT',
} as const;
